import { render, staticRenderFns } from "./BigTree.vue?vue&type=template&id=122212d8&"
import script from "./BigTree.vue?vue&type=script&lang=js&"
export * from "./BigTree.vue?vue&type=script&lang=js&"
import style0 from "./BigTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports